<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						보낸 문자
						<small class="text-nomal m-l-10">보내는 사람 : {{config.item.mberId || '아이디 없음'}} (  {{config.item.callFrom}} )</small>
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
					<div class="config">
						<button class="btn-sm round">안내</button>
					</div>
				</div>
				<div class="modal-body p-10 clearfix" style="min-height: 1px;">
                    <div class="send-box half-width left">
                        <h3 class="send-tit"><span>받는사람</span></h3>
                        <ul class="item-list">
                            <!-- <li v-for="item in recvList" :key="'recvItem-'+item.smsRecvId"> -->
                            <li>
								<span class="name">
									<!-- {{item.callTo || '알 수 없음'}} -->
									{{config.item.callTo || '알 수 없음'}}
								</span>
							</li>
							<!-- </li> -->
                        </ul>
                    </div>
                    <!-- //end .send-box.left -->
					<div class="send-box half-width right">
						<div class="send-box" style="margin-top: 40px;">
							<div class="sms-box">
								<div class="sms-text-box m-b-5">
									<textarea :maxlength="content_max" class="m-t-10" cols="30" v-model="content" rows="14" disabled></textarea>
									<span class="limit-text clearfix">
                                        <span class="pull-right">
                                            {{content.length}}/{{content_max}}<br>sms
                                        </span>
                                    </span>
								</div>
								<!-- //end .sms-text-box -->
							</div>
						</div>
						<p class="w280 m-t-30 m-b-0 center-block">
							<span>보낸일시: 2019년 6월 20일 14:20:10</span>
						</p>
					</div>
					<!-- //end .send-box.right -->
				</div>
				<div class="modal-footer p-15 clearfix">
					<button 
						class="btn full-width bg-deepblue text-white round m-r-5" 
						type="button"
						@click="$emit('close')"
					>확인</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server'// eslint-disable-line no-unused-vars

import _ from 'lodash'// eslint-disable-line no-unused-vars
import moment from 'moment'// eslint-disable-line no-unused-vars

export default {
	name:"ModalSmsSentDetail",

	mounted : function(){
		console.log(this.config);
	},

	default: function(){
		return {
			name: this.name,
			show: false,

			item : ''
		}
	},

	props: {
		config: Object
	},

	data (){
		return {
			modify_mode : false,
			
            content : this.config.item.smsTxt,
            content_max : 50
		}
	},
    computed : {
		recvList(){
			return this.config.item.smsRecvList;
		},
	},
	methods: {
		modifySmsForm(){
			const self = this;
			let item = {
				smsTemplId : this.config.item.smsTemplId,
				content : this.content,
			}

			server.patchAxios('sys/smsTempl', item.smsTemplId, item,({data, err}) => {
				err; data;
				self.$emit('refresh');
				self.modify_mode = !self.modify_mode;
			});
		},

		uploadFile(){

		},
	},
}
</script>

<style scoped>
.down-on {
	fill: #999;
	fill-rule: evenodd;
}
a:hover .down-on {
	fill: #156ea2;
	fill-rule: evenodd;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>